/**
 * Landing Page How It Works Section
 * ZO Bull Algo Trading Platform
 */
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const STEPS = [
  { number: '01', icon: '📝', titleKey: 'howStep1Title', descKey: 'howStep1Desc', detailsKey: ['howStep1Detail1', 'howStep1Detail2', 'howStep1Detail3'] },
  { number: '02', icon: '🔗', titleKey: 'howStep2Title', descKey: 'howStep2Desc', detailsKey: ['howStep2Detail1', 'howStep2Detail2', 'howStep2Detail3'] },
  { number: '03', icon: '📊', titleKey: 'howStep3Title', descKey: 'howStep3Desc', detailsKey: ['howStep3Detail1', 'howStep3Detail2', 'howStep3Detail3'] },
  { number: '04', icon: '📈', titleKey: 'howStep4Title', descKey: 'howStep4Desc', detailsKey: ['howStep4Detail1', 'howStep4Detail2', 'howStep4Detail3'] },
  { number: '05', icon: '🚀', titleKey: 'howStep5Title', descKey: 'howStep5Desc', detailsKey: ['howStep5Detail1', 'howStep5Detail2', 'howStep5Detail3'] },
  { number: '06', icon: '💰', titleKey: 'howStep6Title', descKey: 'howStep6Desc', detailsKey: ['howStep6Detail1', 'howStep6Detail2', 'howStep6Detail3'] },
]

export default function LandingHowItWorks() {
  const { t } = useTranslation();

  return (
    <section className="landing-how-it-works">
      <div className="section-container">
        <div className="section-header">
          <span className="section-badge">🎯 {t('landing.howItWorksTitle')}</span>
          <h2 className="section-title">{t('landing.howItWorksSubtitle')}</h2>
          <p className="section-subtitle">
            {t('landing.howItWorksDesc')}
          </p>
        </div>
        
        <div className="steps-timeline">
          {STEPS.map((step, index) => (
            <div key={index} className={`step-card ${index % 2 === 0 ? 'step-left' : 'step-right'}`}>
              <div className="step-number-badge">{step.number}</div>
              <div className="step-content">
                <div className="step-icon-wrapper">
                  <span className="step-icon">{step.icon}</span>
                </div>
                <h3 className="step-title">{t(`landing.${step.titleKey}`)}</h3>
                <p className="step-description">{t(`landing.${step.descKey}`)}</p>
                <ul className="step-details">
                  {step.detailsKey.map((detailKey, i) => (
                    <li key={i}>
                      <span className="check-icon">✓</span>
                      {t(`landing.${detailKey}`)}
                    </li>
                  ))}
                </ul>
              </div>
              {index < STEPS.length - 1 && (
                <div className="step-connector">
                  <div className="connector-line"></div>
                  <div className="connector-dot"></div>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="how-it-works-cta">
          <Link to="/login" className="btn btn-primary btn-lg">
            {t('landing.startTradingNow')}
          </Link>
          <div className="cta-features">
            <span>✓ {t('landing.freeToStart')}</span>
            <span>✓ {t('landing.noCreditCard')}</span>
            <span>✓ {t('landing.setupInMins')}</span>
          </div>
        </div>
      </div>
    </section>
  )
}
